module.exports = __webpack_public_path__ + "img/keben1.03615ed6.png";